import React from 'react';
import { DriveFileRenameOutline } from '@mui/icons-material';
import { gsToDoFilter } from '../filters';
import {
  ApplicationViewList,
  type ApplicationViewTableDataItem,
  type CustomAction,
  type ApplicationViewListProps,
  type TableColumns,
  type FilterFields,
} from '../../../../Application/components';

import { APPLICATION_STATUS_TYPE } from '../../../../../utils';

export const GSDecisionList: React.FunctionComponent = () => {
  const handleSwitchGSDecision = (row: ApplicationViewTableDataItem): void => {
    const { applicationId } = row;
    window.open(`/internal/gs-homepage/gsassessment/details/${applicationId}`);
  };

  const initialVisibleColumns: TableColumns[] = React.useMemo(
    () => [
      'applicationNo',
      'applicantName',
      'department',
      'confirmedChiefSupervisor',
      'entryYear',
      'applyProgramme',
      'nominatedFundings',
      'applicationStatus',
      'applicationSubmissionTime',
      'gsSubmissionTime',
      'gsAssignee',
    ],
    [],
  );

  const hiddenFilters: FilterFields[] = React.useMemo(
    () => [
      'applicantIdentityType',
      'applicantLocalIndicator',
      'scholarshipAppliedByApplicant',
      'applicationStatus',
      'fundingSchemeStatus',
      'fundingScheme',
      'applicationStatus',
    ],
    [],
  );

  const filterProps: ApplicationViewListProps['filterProps'] = {
    hiddenFilterFields: hiddenFilters,
  };

  const customActions: CustomAction[] = [
    {
      icon: <DriveFileRenameOutline />,
      handleAction: handleSwitchGSDecision,
      checkDisable: row => {
        const status = row.applicationStatusRaw;
        return !(
          status === APPLICATION_STATUS_TYPE.UNDER_GS ||
          status === APPLICATION_STATUS_TYPE.FRCSB_ASSESSED
        );
      },
    },
  ];

  const sort = {
    assessment: {
      lastSubmissionTime: { at: 'ASC' },
    },
  };

  const tableProps: ApplicationViewListProps['tableProps'] = {
    initialVisibleColumns,
    listFilter: gsToDoFilter,
    sort,
    customActions,
  };

  return (
    <ApplicationViewList tableProps={tableProps} filterProps={filterProps} />
  );
};
